import { makeStyles } from '@material-ui/core';
import Background from 'assets/images/App-Background.jpg';

const useStyles = makeStyles((theme) => ({
  fullPageContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundImage: `url(${Background})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundColor: 'rgba(0, 0, 0, 0.85)',
    backdropFilter: 'blur(10px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
    overflow: 'hidden',
  },
  backButton: {
    position: 'absolute',
    top: theme.spacing(3),
    left: theme.spacing(3),
    color: '#ffffff',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    zIndex: 2,
    '&:hover': {
      backgroundColor: 'rgba(255, 152, 0, 0.2)',
    },
    [theme.breakpoints.down('sm')]: {
      top: theme.spacing(2),
      left: theme.spacing(2),
      padding: theme.spacing(1),
    },
  },
  content: {
    position: 'relative',
    zIndex: 1,
    textAlign: 'center',
    padding: theme.spacing(4),
    maxWidth: '600px',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
      maxWidth: '90%',
    },
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1.5),
      maxWidth: '95%',
    },
  },
  title: {
    fontSize: '32px',
    fontWeight: 700,
    color: '#ffffff',
    marginBottom: 0,
    letterSpacing: '1px',
    textTransform: 'uppercase',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1.5),
    [theme.breakpoints.down('sm')]: {
      fontSize: '24px',
      flexDirection: 'column',
      gap: theme.spacing(1),
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '20px',
      letterSpacing: '0.5px',
    },
  },
  emoji: {
    fontSize: '36px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '28px',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '24px',
    },
  },
  divider: {
    width: '100%',
    height: '1px',
    backgroundColor: '#ff9800',
    margin: theme.spacing(3, 0),
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(2, 0),
    },
  },
  mainMessage: {
    fontSize: '18px',
    fontWeight: 500,
    color: '#ffffff',
    marginBottom: theme.spacing(1.5),
    lineHeight: 1.8,
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      marginBottom: theme.spacing(1),
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '14px',
      lineHeight: 1.6,
    },
  },
  subMessage: {
    fontSize: '18px',
    fontWeight: 500,
    color: '#ffffff',
    marginBottom: theme.spacing(6),
    lineHeight: 1.8,
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      marginBottom: theme.spacing(4),
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '14px',
      marginBottom: theme.spacing(3),
      lineHeight: 1.6,
    },
  },
  logoContainer: {
    marginTop: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(3),
    },
    [theme.breakpoints.down('xs')]: {
      marginTop: theme.spacing(2),
    },
  },
  logo: {
    height: '60px',
    opacity: 1,
    [theme.breakpoints.down('sm')]: {
      height: '50px',
    },
    [theme.breakpoints.down('xs')]: {
      height: '40px',
    },
  },
  logoText: {
    fontSize: '16px',
    fontWeight: 400,
    color: '#ff9800',
    marginTop: theme.spacing(1),
    textAlign: 'center',
    fontStyle: 'italic',
  },
}));

export default useStyles;
